import React from 'react'

export default ({ children }) => (
   <div className="body-container">
   
   {children}
   
   </div>

)



// WEBPACK FOOTER //
// ./src/components/container.js